export default __webpack_public_path__ + "static/media/stella_bio_purple_led.428fa2d4.png";